import { ValidationError } from "../errors";
import { browserStore } from "./storageKeys";

const TENANT_KEY = "tenant";

/**
 * The tenant the user signed in as. Null before login — callers that merely interpolate it into a
 * header, tag or URL should pick their own fallback explicitly rather than assuming one.
 */
export const getTenant = (): string | null => browserStore.get(TENANT_KEY);

/** The tenant, or a user-facing error. For paths that cannot proceed without one. */
export const requireTenant = (): string => {
  const tenant = getTenant();
  if (!tenant) throw new ValidationError("No tenant is loaded. Sign in again.");
  return tenant;
};

export const setTenant = (tenant: string): void => browserStore.set(TENANT_KEY, tenant);
